import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmService } from '../confirm/confirm.service';
import { ActualizacionMasivaPreciosFallasService } from '../actualizacion-masiva-precios-fallas/actualizacion-masiva-precios-fallas.service';

@Component({
  selector: 'app-listado-fallas',
  templateUrl: './listado-fallas.component.html',
  styleUrls: ['./listado-fallas.component.css']
})
export class ListadoFallasComponent implements OnInit {

  constructor(private service : UserService, private toast: ToastrService, private confirm : ConfirmService, private actualizacionMasivaPreciosFallasService: ActualizacionMasivaPreciosFallasService) { }

  filtro = "";

  editedFalla: any;

  fallas = [];
  nuevaFallas: any = { 
    nombre: "",
    descripcion: "",
    precio: 0,
    identificador: "",
    categoria: ""
  }

  ngOnInit() {
    this.getFallas();
  }

  getFallas(){
    this.service.getFallas().subscribe(d=>{
      this.fallas = d;
    })
  }

  postFalla(){
   
    console.log(this.nuevaFallas);

    if(this.validateFalla(this.nuevaFallas) == 0) return;

    this.service.postFallas(this.nuevaFallas).subscribe(d=>{
      this.fallas.push(d);
      this.nuevaFallas = { 
        nombre: "",
        descripcion: "",
        precio: 0,
        identificador: "",
        categoria: ""
      }
      this.toast.success("Falla agregada con éxito");
    }, er=>{
      console.log(er);
      return this.toast.error("Error");
    })

  }

  editFalla(f){
    this.editedFalla = JSON.parse(JSON.stringify(f));
  }


  putFalla(falla){
    if(this.validateFalla(falla)==0) return;

    this.service.putFallas(falla).subscribe(d=>{
      this.getFallas();
      this.editedFalla = null;
    })
  }

  eliminar(falla){
    this.confirm.confirm("Eliminar falla", "Esta seguro de eliminar la falla " + falla.nombre + "?").then((confirmated) =>{
      this.service.deleteFalla(falla._id).subscribe(d=>{
        this.getFallas();
        this.editedFalla = null;
      })
    });
  }

  validateFalla(falla){
    if(falla.nombre.length<1){
      this.toast.error("Nombre invalido");
      return 0;
    } 
    if(falla.descripcion.length<1){
      this.toast.error("Descripcion invalido");
      return 0;
    } 
    if(falla.categoria.length<1){
      this.toast.error("Categoría invalido");
      return 0;
    } 
    if(falla.identificador.length<1){
      this.toast.error("Identificador invalido");
      return 0;
    } 
    try{
      falla.precio = parseFloat(falla.precio);
      if(isNaN(falla.precio)){
        this.toast.error("Precio invalido");
        return 0;
      } 
    }
    catch(er){
      this.toast.error("Precio invalido");
      return 0;
    }

    return 1;
  }



  actualizacionMasivaPrecios(){
    this.actualizacionMasivaPreciosFallasService.show(this.fallas, "Actualizar precios de fallas", "", "OK", "Cancelar", "lg").then( result =>{
      console.log("Success");
      this.fallas = [];
      this.getFallas();
      
    }).catch( error =>{
      console.log("ERROR");
      
    })
  }
}
